import { RxHamburgerMenu } from "react-icons/rx"
import { MdOutlineClose } from "react-icons/md"
import { MdLanguage } from "react-icons/md"
import { Link, NavLink } from "react-router-dom"

import logo from "../img/Logo.svg"
import call from "../img/call.gif"
import mapImg from "../img/mapImg.gif"
import { useEffect, useState } from "react"
import { Fade, Grow, Slide } from "@mui/material"
import timeout from "../data/timeout"
import info from "../data/info"
import SocialNetButtons from "./Main/SocialNetButtons"
import { logMessage } from "../utils/utils"
const nav = [
  {
    titleUa: "Головна",
    titleEn: "Home",
    link: "/",
  },
  {
    titleUa: "Послуги",
    titleEn: "Services",
    link: "services",
  },
  {
    titleUa: "Ціни",
    titleEn: "Prices",
    link: "prices",
  },
  // {
  //   titleUa: "Заявка",
  //   titleEn: "",
  //   link: "orderform",
  // },

  {
    titleUa: "Контакти",
    titleEn: "Contacts",
    link: "contacts",
  },
]
const scrollUp = () => {
  window.scrollTo({ top: 0, behavior: "smooth" })
}

const Header = () => {
  const [appearMenu, setAppearMenu] = useState(false)
  const [appearCall, setAppearCall] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setAppearCall(true)
    }, 1000)
  })

  const toggleMenu = () => setAppearMenu(!appearMenu)
  const turnOffMenu = () => setAppearMenu(false)

  return (
    <div>
      <Slide direction="down" in timeout={timeout + 400}>
        <header className="fixed w-full top-0 h-[61px] px-2 sm:px-4 md:px-6 bg-[#010204]/[.80] z-10 flex items-center justify-between">
          <Link to="/">
            <p
              className="text-white  text-2xl tn: xs: sm: md:text-3xl"
              onClick={() => {
                scrollUp()
                turnOffMenu()
              }}
            >
              Comp-Service
            </p>
            {/* <img
              src={logo}
              className="w-[200px] tn:w-[230px] xs:w-[175px] sm:w-[230px] md:w-[250px]"
              onClick={() => {
                scrollUp()
                turnOffMenu()
              }}
            /> */}
            {/* <div
              className="text-white text-2xl tn:text-3xl sm:text-4xl"
              onClick={() => {
                scrollUp()
                turnOffMenu()
              }}
            >
              R-SERVICE
            </div> */}
          </Link>
          <div className="flex items-center">
            <div className="flex items-center justify-center">
              <ul className="hidden xs:w-[285px] sm:w-[325px] md:w-[400px] xs:text-sm sm:text-base md:text-lg text-white xs:flex justify-between">
                {nav.map((el) => (
                  <NavLink
                    to={el.link}
                    onClick={() => {
                      scrollUp()
                      logMessage(el.titleUa)
                    }}
                    key={el.titleUa}
                    className=" lg:hover:text-[#668efcef] lg:hover:underline underline-offset-2 lg:hover:scale-105 lg:hover:cursor-pointer duration-200"
                  >
                    {el.titleUa}
                  </NavLink>
                ))}
              </ul>
              {!appearMenu ? (
                <RxHamburgerMenu
                  className="text-2xl tn:text-3xl text-white xs:hidden"
                  onClick={() => {
                    toggleMenu()
                    logMessage("Меню")
                  }}
                />
              ) : (
                <MdOutlineClose
                  className="text-3xl tn:text-4xl text-white xs:hidden"
                  onClick={() => {
                    toggleMenu()
                    logMessage("Меню закрити")
                  }}
                />
              )}
            </div>
          </div>
        </header>
      </Slide>
      {/* {appearMenu && ( */}
      <Fade timeout={timeout} in={appearMenu}>
        <div className="fixed w-screen h-screen bg-black opacity-95 z-20 border-t mt-[61px] xs:hidden">
          <div className="z-30 mt-10 ">
            <ul className="flex flex-col text-3xl text-white ">
              {nav.map((el) => (
                <Link
                  to={el.link}
                  onClick={() => {
                    scrollUp()
                    logMessage(el.titleUa)
                    turnOffMenu()
                  }}
                  key={el.titleUa}
                  className="mt-3 lg:hover:text-[#668efcef] lg:hover:underline underline-offset-2 lg:hover:scale-105 lg:hover:cursor-pointer duration-200"
                >
                  {el.titleUa}
                </Link>
              ))}
            </ul>
          </div>
        </div>
      </Fade>
      {/* )} */}
      <Fade timeout={2000} in={appearCall}>
        <div>
          <div className="fixed bottom-10 left-5 sm:right-10">
            <SocialNetButtons />
          </div>

          <a
            href={info.mapWay}
            target="_blank"
            className="fixed w-14 bottom-10 right-24 sm:right-[114px]"
            onClick={() => logMessage("Локація")}
          >
            <img
              src={mapImg}
              alt="mapImg"
              className="rounded-3xl shadow-[0px_0px_20px_5px] shadow-[#002898]/[.80] animate-pulse opacity-90 border-2 border-[#000]/[.80]"
            />
          </a>

          <a
            href={info.tel.number}
            className="fixed w-14 bottom-10 right-5 sm:right-10"
          >
            <img
              src={call}
              alt="call"
              className="rounded-3xl shadow-[0px_0px_20px_5px] shadow-[#002898]/[.80] animate-pulse opacity-90 border-2 border-[#000]/[.80]"
              onClick={() => logMessage("Телефон")}
            />
          </a>
        </div>
      </Fade>
    </div>
  )
}

export default Header
